import React, { createContext, useContext, useEffect, useState,useMemo } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msalConfig"; // Importa la configurazione di MSAL
import { setCookie } from "./../../utils/cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const { instance, inProgress,accounts } = useMsal();
    const [token, setToken] = useState(null);

    const getToken = async () => {
        if (accounts.length > 0) {
            try {
                const response = await instance.acquireTokenSilent({
                    ...loginRequest,
                    account: accounts[0],
                });
                setToken(response.accessToken);
                //setCookie("is_active_directory",true);  


            } catch (error) {
                console.error("Errore durante l'acquisizione del token:", error);
            }
        }
    };

    useEffect(() => {
        // Acquisisci il token solo quando MSAL è pronto
        if (inProgress === "none") {
            getToken();
        }
    }, [inProgress, accounts, instance]); // Dipendenze aggiunte per sicurezza

    // Aggiorna il contesto ogni volta che il token cambia
    const contextValue = useMemo(() => ({ 
        token, 
        setToken, 
        refreshToken: getToken // Per un aggiornamento manuale, se necessario
    }), [token]);


    

    return (
        <AuthContext.Provider value={{ token, setToken }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook per usare il contesto in qualsiasi componente
export const useAuth = () => useContext(AuthContext);
